/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.JobWork {
    import fld = JobWorkReturnBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnBOMEditor extends Common.GridEditorBase<JobWorkReturnBOMRow> {
        protected getColumnsKey() { return "JobWork.JobWorkReturnBOM"; }
        protected getDialogType() { return JobWorkReturnBOMDialog; }
        protected getLocalTextPrefix() { return JobWorkReturnBOMRow.localTextPrefix; }
        protected form: JobWorkReturnBOMForm;
        private pendingChanges: Q.Dictionary<any> = {};

        public PartyId: number;
        public TransID: number;
        public VoucherTypeId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public oldweights: any[];
        public oldpieces: any[];
        public BOMProductId: any[];
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));


        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
     Q.first(columns, x => x.field === fld.Weight).format = num;

            let piecesColumn = Q.first(columns, x => x.field == fld.Pieces);

            piecesColumn.format = ctx => {
                if (ctx.item.ItemTypeId == "105")
                    return ColumnFormatter.integerInputFormatter(ctx, this);
                else
                    return this.integerReadOnlyFormatter(ctx);
            }

            return columns;
        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
         
            // *** Validate Decimal & Integer***
           if (field === fld.Pieces || field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            //to get old jobtransaction values
            var olddata: Stock.JobTransactionRow;
            if (item.TransBomId != undefined) {
                Stock.JobTransactionService.CustomJobTransactionList({
                    ProductId: item.BOMProductId, AttributeId: item.BOMAttributeId, LedgerId: this.PartyId, TransId: this.TransID, VoucherTypeId: this.VoucherTypeId
                }, function (response) {
                    return olddata = response.Entity;
                }, { async: false });
            } else {
                Stock.JobTransactionService.CustomJobTransactionList({
                    ProductId: item.BOMProductId, AttributeId: item.BOMAttributeId, LedgerId: this.PartyId
                }, function (response) {
                    return olddata = response.Entity;
                }, { async: false });
            }
            // *** Update Weight, Amount etc on Pieces Change***
        
            if (field === fld.Pieces && value > 0) {
                if (item.ItemTypeId == 105) {
                    var old_pieces = olddata.Pieces;//before edit pieces
                    if (item.CalcOnId == 3) {
                       
                        if (value <= old_pieces) {
                       //     item.BomAmount = item.BomRate * value;
                            item[field] = value;
                        }
                        else {
                            Q.alert('Invalid Pieces')
                        }
                    }
                    else {
                       
                        if (value <= old_pieces) {
                            item[field] = value;
                        }
                        else {
                            Q.alert('Invalid Pieces')
                        }
                    }
                }
            }

            else if (field === fld.Weight && value > 0) {
                if (item.ItemTypeId == 105) {
                    if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                        var old_weight = olddata.Weight;//before edit weight
                            if (value <= old_weight) {
                                item[field] = value;
                            }
                            else {
                                Q.alert('Invalid Weight')
                            }
                        
                    }

                }
            }


            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        // **** For Integer Editor in Grid ****
        private integerReadOnlyFormatter(ctx) {
          
            var item = ctx.item;
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            var width = (ctx.column.width) as number - 10;
            //if (pending && pending[ctx.column.field] !== undefined) {
            //    klass += ' dirty';
            //}
            var value = this.getEffectiveValue(item, ctx.column.field) as number;
            return value === undefined
                ? "<input type='submit' style='text-align: right; width:" + width + "px; data-field='" + ctx.column.field +
                "' value=''/>"
                : "<input type='submit' style='text-align: right; width:" + width + "px;data-field='" + ctx.column.field +
                "' value='" + Q.formatNumber(value, '0') + "' />";
        }
        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }
        protected getButtons() {
            let buttons = super.getButtons();
            // buttons.pop();
            var grid = Stock.JobTransactionSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            buttons.push({
                title: "Select Stone",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        let bomdetails=[];
                        var ratelistId = this.RateListId;
                        //alert(selectedItems2.length);
                        selectedItems2.forEach(function (value) {
                            var prdid = value.ProductId;
                            var atbid = value.AttributeId;
                            //alert(prdid);
                           
                            var atb = value;

                            var atbCode =atb.Attribute;
                            var ItmTpy =atb.ItemType;
                            var ItmTpyId =atb.ItemTypeId; 
                            var SubTypeID =atb.SubCategoryId; 
                            var KaratId =atb.KaratId;
                            var StoneColorID =atb.StoneColorId;
                            var MetalColorId =atb.MetalColorId;
                            var CalcOn = value.CalcOnId;

                            var ShapeID =atb.ShapeId; 
                            var QualityId =atb.QualityId;
                            var Purity = value.Purity;
                            var Pieces = 0;
                            var Weight = 0.01;
                            var Rate = 0;
                            var Amount = 0;

                            if (SubTypeID == 301 || SubTypeID == 302 || SubTypeID == 303 || SubTypeID == 304) {
                                var MetalRate = GetItemRateHelper.GetGetMetalRate(SubTypeID);
                                Rate = MetalRate;
                                Amount = Rate * Weight * Purity;

                            }
                            else {
                                var ItemRate = GetItemRateHelper.GetPurchaseRate(atb.AttributeId, ratelistId);
                                Rate = ItemRate;
                                Pieces = 1;
                                if (CalcOn == 3) {
                                    Amount = Rate * Pieces
                                }
                                else {
                                    Amount = Rate * Weight;
                                }
                            }


                            var Bom: JobWorkReturnBOMRow = {
                                BOMProductId: prdid,
                                ProductName: value.ProductName,
                                ProductCode: value.ProductCode,
                                BOMAttributeId: value.AttributeId,
                                Attribute: atbCode,
                                ItemType: ItmTpy,
                                ItemTypeId: ItmTpyId,


                                StoneColorId: StoneColorID,
                                MetalColorId: MetalColorId,
                                KaratId: KaratId,

                                BomRate: value.Rate,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                CalcOn: value.CalcOn,
                                ShapeId: ShapeID,
                                QualityId: QualityId,
                                BomAmount: Amount,
                                PureWeight: value.PureWeight == undefined ? 0 : value.PureWeight,
                                Purity:value.Purity==undefined?0:value.Purity
                                
                            };
                            bomdetails.push(Bom);

                        });

                        
                        for (let bomDetail of bomdetails) {
                            
                            bomDetail[this.getIdProperty()] = "`" + this.nextId++;
                            if (this.validateEntity(bomDetail, bomDetail.TransBomId)) { 
                                this.view.addItem(bomDetail);
                                this.oldpieces.push(bomDetail.Pieces);
                                this.oldweights.push(bomDetail.Weight);
                                this.BOMProductId.push(bomDetail.BOMProductId);
                            }
                        }
                        
                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.BOMProductId === row.BOMProductId && x.BOMAttributeId === row.BOMAttributeId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Product already exists!');
                return false;
            }
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }
    }
}